import { render } from "./ForgeHubClassic.vue?vue&type=template&id=4dc487f8&scoped=true&ts=true"
import script from "./ForgeHubClassic.vue?vue&type=script&lang=ts"
export * from "./ForgeHubClassic.vue?vue&type=script&lang=ts"

import "./ForgeHubClassic.vue?vue&type=style&index=0&id=4dc487f8&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc487f8"]])

export default __exports__